import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { BaseEntity, Currency, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';

export enum ScheduledTransactionSettingsMode {
    Manual = 'manual',
    Automatic = 'automatic',
    Scheduled = 'scheduled',
}

export enum ScheduledTransactionPeriod {
    daily = 'daily',
    weekly = 'weekly',
    monthly = 'monthly',
}

export const ScheduledTransactionSettingsZodObject = z
    .object({
        period: EnumSchema(ScheduledTransactionPeriod).optional(),
        mode: EnumSchema(ScheduledTransactionSettingsMode),
        value: z.number().int().min(1).max(31).optional(),
        account: z.string().optional(),
        currency: EnumSchema(Currency),
    })
    .strict();

export const ScheduledTransactionSettingsSchema = WithBaseEntitySchema(ScheduledTransactionSettingsZodObject);

export class ScheduledTransactionSettings extends FromSchema(ScheduledTransactionSettingsSchema) implements BaseEntity {
    id: string;
    period?: ScheduledTransactionPeriod;
    mode: ScheduledTransactionSettingsMode;
    value?: number;
    account?: string;
    currency: Currency;
    createdAt: Date;
    updatedAt: Date;
    tenantId: string;
    createdBy?: Executor;
    seller: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
